<template>
  <div id="app">
    <HomePage></HomePage>
    <transition name="rule">
      <RulePop v-if="isShowRulePop"></RulePop>
    </transition>

    <transition name="qr">
      <QrPop v-if="isShowQrPop"></QrPop>
    </transition>

  </div>
</template>
<script>
import HomePage from '@/components/HomePage'
import RulePop from '@/components/RulePop'
import QrPop from '@/components/QrPop'

import store from '@/store'
import Vuex from 'vuex'

export default {
  name: 'App',
  components: {
    HomePage,
    RulePop,
    QrPop
  },
  created() {

  },
  //模板已编译完，开始挂载，页面就显示出来了。接口请求一般放mounted这里
  //，显示完之后，再显示数据。（服务端渲染不支持mounted，需要放到created）
  mounted() {
    // this.checkLogin();
  },
  methods: {
    // checkLogin() {
    //   var that = this;
    //   window.sys_user.ready = function (userinfo) {  //是否登录都会执行
    //     if (userinfo.username) { //登录


    //       window.uid = userinfo.uid;

    //       that.$store.commit('login');

    //       console.warn("==初始化 已登录 ==");
    //       console.info("========用户信息=========");
    //       console.log(userinfo);
    //       console.info("=================");

    //       // 已登录  请求 点击按钮  打标签
    //       // that.axiosUserClcik(btnName);
    //     } else {
    //       console.warn("==初始化 未登录  ==");
    //     }
    //   }
    //   window.sys_user.inWxLogin = 2;//在微信端  1：打开时直接登录，2：程序请求登录  默认1
    //   //程序执行
    //   window.sys_user.checkuser();
    // }
  },
  computed: {
    // 使用 mapGetters 辅助函数来映射 Vuex getter 到计算属性
    isShowRulePop: function () {
      return this.$store.getters.isShowRulePop;
    },
    isShowQrPop: function () {
      return this.$store.getters.isShowQrPop;
    }
  }
}
</script>
<style lang="less">
.rule-enter-active,
.rule-leave-active {
  transition: transform 0.4s, opacity 0.4s;
}

.rule-enter,
.rule-leave-to {
  transform: scale(0.4);
  opacity: 0;
}

.qr-enter-active,
.qr-leave-active {
  transition: transform 0.4s, opacity 0.4s;
}

.qr-enter,
.qr-leave-to {
  transform: scale(0.4);
  opacity: 0;
}

body,
html {
  position: relative;
  width: 100%;
  // max-width: 750px!important;
  height: 100%;
  padding: 0;
  margin: 0;
  /* background-color: #ffffff; */
  -webkit-apperance: none;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
}
img:active{
  -webkit-transform: scale(1);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: 0;
  margin: 0 auto;
  // width: 100%;
  width: 100%;
  // max-width: (750/@vw);
  // max-width: 750px;
  min-height: 100%;
}
</style>
